module.exports = __webpack_public_path__ + "img/testim2.80359048.webp";